module.exports = __webpack_public_path__ + "img/2_no.e8c48103.svg";